import { render } from "./CompassRose.vue?vue&type=template&id=33d43409"
import script from "./CompassRose.vue?vue&type=script&lang=js"
export * from "./CompassRose.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__